import { initializeApp, getApps } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app = getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);
let authInstance: Auth;
let dbInstance: Firestore;
let storageInstance: FirebaseStorage;

try {
  authInstance = getAuth(app);
} catch (e) {
  console.warn("[Firebase Auth] Initialization warning:", e);
  authInstance = {} as Auth;
}

try {
  dbInstance = getFirestore(app);
} catch (e) {
  console.warn("[Firebase Firestore] Initialization warning:", e);
  dbInstance = {} as Firestore;
}

try {
  storageInstance = getStorage(app);
} catch (e) {
  console.warn("[Firebase Storage] Initialization warning:", e);
  storageInstance = {} as FirebaseStorage;
}

export const auth = authInstance;
export const db = dbInstance;
export const storage = storageInstance;
